import { ACKODRIVE_LOGO_HORIZONTAL_DARK, ACKODRIVE_LOGO_HORIZONTAL_LIGHT, ACKODRIVE_LOGO_VERTICAL_DARK } from '@constants/ackodriveLogo'

export const enum backgroundColor {
    dark = 'dark',
    light = 'light'
}

export const enum textAlignment {
    horizontal = 'horizontal',
    vertical = 'vertical'
}

export const ackodriveLogoConfig = {
    [backgroundColor.dark]: {
        [textAlignment.horizontal]: {
            src: ACKODRIVE_LOGO_HORIZONTAL_DARK,
            alt: 'Ackodrive Horizontal Dark Background',
            fill: true,
        },
        [textAlignment.vertical]: {
            src: ACKODRIVE_LOGO_VERTICAL_DARK,
            alt: 'Ackodrive Vertical Dark Background',
            width: 76,
            height: 36,
        },
    },
    [backgroundColor.light]: {
        [textAlignment.horizontal]: {
            src: ACKODRIVE_LOGO_HORIZONTAL_LIGHT,
            alt: 'Ackodrive Horizontal Light Background',
            width: 100,
            height: 46,
            style: { objectFit: 'scale-down' },
        }
    },
}

export const backgroundColorConfig = {
    true: backgroundColor.dark,
    false: backgroundColor.light
}

export const textAlignmentConfig = {
    true: textAlignment.vertical,
    false: textAlignment.horizontal
}
